import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';

import { useAppSelector } from 'app/hooks';
import Row from 'blocks/Row';
import { Text } from 'blocks/Text';
import LanguageSwitcher from 'components/LanguageSwitcher';
import MenuDrawer from 'components/Sidebar/menu';
import { toggleDrawer, useLayoutDispatch } from 'context/HamberProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getTiersService } from 'services/Tiers.service';
import { UserTierState, setTier, setTiersError, setTiersLoading } from 'store/tiers/tiersSlice';
import * as S from './Header.styles';
const Header: React.FC = () => {
  const { t } = useTranslation();

  const userTiers = useAppSelector(UserTierState);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isTabletSize = useMediaQuery(theme.breakpoints.down('md'));
  const LayoutDispatch = useLayoutDispatch();
  const tiers = [
    {
      title: t('layout.header.memberShip'),
      value: userTiers?.idNumber,
    },
    {
      title: t('layout.header.rewardMiles'),
      value: userTiers?.rewardMilage,
    },
    {
      title: t('layout.header.tierMiles'),
      value: userTiers?.tierMilage,
    },
  ];
  useEffect(() => {
    if (!userTiers || !tiers) {
      getUserTier();
    }
  }, []);

  const getUserTier = async () => {
    dispatch(setTiersLoading());
    getTiersService()
      .then((res) => {
        dispatch(setTier(res.data));
      })
      .catch((err) => {
        dispatch(setTiersError({ err }));
      });
  };

  return (
    <S.Header>
      <S.HeaderRow as={Row} justify="space-between" align="center">
        {isTabletSize && (
          <S.IconButton as={IconButton} onClick={() => toggleDrawer(LayoutDispatch)}>
            <MenuIcon />
          </S.IconButton>
        )}
        {isTabletSize ? <MenuDrawer /> : null}
        <S.RightBox as={Row} align="center" className="user">
          {tiers.map((e, i) => {
            return (
              <S.User key={i}>
                <S.Key>{e.title}</S.Key>
                <Text size="small" bold>
                  {e.value}
                </Text>
              </S.User>
            );
          })}
        </S.RightBox>
        <LanguageSwitcher />
      </S.HeaderRow>
    </S.Header>
  );
};

export default Header;
